// extracted by mini-css-extract-plugin
export default {"ContainerStyles":"ScoreStep_ContainerStyles__wofaW","LabelStyles":"ScoreStep_LabelStyles__Gmmav","StepName":"ScoreStep_StepName__nVljs"};